export default __webpack_public_path__ + "static/media/portfolio-footer.de184ebb.svg";